'use client'

import Link from 'next/link'
import { ArrowUpRight, Check } from 'lucide-react'
import { aileLabels } from '../data/pricing'
import { usePricing } from '../hooks/use-landing'
import s from '../styles/landing.module.css'

export function EditorialPricing() {
  const { family, setFamily, tiers } = usePricing()
  return <section id="pricing" className={`${s.section} ${s.pricing}`} aria-labelledby="pricing-title">
    <div className={s.pricingHeader}>
      <h2 id="pricing-title">Size uygun bir<br />başlangıç var.</h2>
      <div><p>Ofisinizin ya da şirketinizin ihtiyacına göre seçin.</p><div className={s.familyToggle} role="group" aria-label="Hesap türü"><button type="button" aria-pressed={family === 'MUSAVIR'} onClick={() => setFamily('MUSAVIR')}>{aileLabels.MUSAVIR}</button><button type="button" aria-pressed={family === 'SIRKET'} onClick={() => setFamily('SIRKET')}>{aileLabels.SIRKET}</button></div></div>
    </div>
    <div className={s.planList} aria-live="polite">
      {tiers.map(tier => <article className={s.plan} key={tier.name}>
        <div><h3>{tier.name}</h3><p>{tier.description.replace(' en popüler paket', '')}</p></div>
        <ul>{tier.features.map(feature => <li key={feature}><Check size={14} aria-hidden="true" />{feature}</li>)}</ul>
        <div className={s.planAction}><p className={s.price}>{tier.price}<span>{tier.period}</span></p><Link className={s.textLink} href={tier.price === 'Özel fiyat' ? 'mailto:info@tuppa.com.tr' : '/kayit'}>{tier.price === 'Özel fiyat' ? 'İletişime geç' : 'Hesap oluştur'}<ArrowUpRight size={16} /></Link></div>
      </article>)}
    </div>
    <p className={s.pricingNote}>Paket kapsamı ve güncel koşullar hesap açılışında sunulur.</p>
  </section>
}
